<template>
    <div>
        <div class="applicationSystemAlarm-title">{{$t('smartMonitor.applicationSystemAlert.title')}}</div>
        <div class="applicationSystemAlarm-top">
            <application-system-alarm-search></application-system-alarm-search>
        </div>
        <table-application-system-alarm></table-application-system-alarm>
    </div>
</template>

<script>
    import TableApplicationSystemAlarm from '../application_system_alarm/TableApplicationSystemAlarm'
    import ApplicationSystemAlarmSearch from '../application_system_alarm/ApplicationSystemAlarmSearch'
    export default {
        name: 'ApplicationSystemAlarm',
        components: {
            TableApplicationSystemAlarm,
            ApplicationSystemAlarmSearch
        }
    }
</script>

<style scoped>
    .applicationSystemAlarm-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .applicationSystemAlarm-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_system_alarm/ApplicationSystemAlarm.vue